const UPLOAD_FOLDER_BASE_URL = "http://localhost:3001/uploads/";

const stables = { UPLOAD_FOLDER_BASE_URL };

export default stables;
